import React from "react";
import styled from "styled-components";

import { convertPxToRem } from "frontend/components/helpers";
import colors from "core/colors";

const GridItemContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colors.primary.diamond};
    width: ${convertPxToRem(175)};
    height: ${convertPxToRem(175)};

    & img {
        width: 61.475%;
        height: 61.475%;
    }
`;

export const generateGridItems = (
    imageTitleAndThumbnailList,
    gridSize = 25
) => {
    if (!imageTitleAndThumbnailList.length) return [];

    let imageList = imageTitleAndThumbnailList.slice(0, gridSize);
    completeImageList();

    return imageList.map(({ thumbnail, title }, idx) => (
        <GridItemContainer key={idx} src={thumbnail}>
            <img src={thumbnail} alt={`${title} Icon`} />
        </GridItemContainer>
    ));

    // repeats images for grid when provided image list length is less than grid size
    function completeImageList() {
        if (imageList.length < gridSize) {
            const diff = gridSize - imageList.length;
            const slice = imageTitleAndThumbnailList.slice(0, diff);

            imageList = [...imageList, ...slice];

            return completeImageList();
        }
    }
};
